<script>
  import Photos from '@app-components/rec_object/parts/Photos.svelte';
  import PostInformation from './PostInformation.svelte';
  import jQuery from 'jquery';
  import Track from '@utils/track';
  import PreloadBox from '@components/PreloadBox.svelte';

  export let mobile = false;
  export let hovered = false;
  export let postInformation;
  export let user;
  export let group;
  export let viewType = 'embed-post';
  let instagram = postInformation['platform'] == 'instagram';
  let link = postInformation['url'];
  let mediaMap = postInformation.media_items.map((item, index) => ({
    id: index,
    item_id: item.id,
    cover: item.cover,
    content_type: item.content_type,
    view_urls: {
      full_size: item.content_url,
    },
  }));

  let handleOpenLink = function () {
    instagram
      ? Track.embedOpenInstagram({ currentUser: user, group: group, link })
      : Track.embedOpenTiktok({ currentUser: user, group: group, link });
    window.open(link, '_blank').focus();
    for (var i = 0; i < mediaMap.length; i++) {
      if (mediaMap[i].content_type == 'video') {
        handleVideoClose(mediaMap[i].item_id);
      }
    }
  };
  let handleVideoClick = function (itemId, forceClose = false) {
    let video = document.getElementById(`video-player-${itemId}-${viewType}`);
    if (video) {
      let playButton = jQuery(`#player-button-${itemId}-${viewType}`);
      let externalLink = jQuery(`#external-platform-link-${postInformation.id}-${viewType}`);
      let postInformationElem = jQuery(`#post-information-${postInformation.id}-${viewType}`);
      if (video.paused && !forceClose) {
        video.play();
        playButton?.addClass('hidden');
        externalLink?.addClass('hidden');
        postInformationElem?.addClass('hidden');
        let link = video.getAttribute('data-attr-link');
        instagram
          ? Track.embedPostInstaVideoPlay({ currentUser: user, group: group, link: link })
          : Track.embedPostTiktokVideoPlay({ currentUser: user, group: group, link: link });
      } else {
        video.pause();
        playButton?.removeClass('hidden');
        externalLink?.removeClass('hidden');
        postInformationElem?.removeClass('hidden');
      }
    }
  };
  let handleVideoClose = function (itemId) {
    handleVideoClick(itemId, true);
  };
  let handleInformationClick = function (itemId) {
    handleVideoClick(itemId);
  };

  setTimeout(() => {
    jQuery('.preload-box').addClass('hidden');
    jQuery('.image-container').removeClass('hidden');
  }, 1000);
</script>

<style style="text/scss" lang="scss">
  .image-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    cursor: pointer;
    width: 280px;
    min-height: 280px;

    .group-images {
      border-radius: 12px;
      background: #000;
      position: relative;
      overflow: hidden;
      .external-platform-link {
        color: #fff;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        display: flex;
        align-items: center;
        gap: 6px;
        left: 16px;
        bottom: 23px;
        position: absolute;
        cursor: pointer;
        z-index: 1;
        &:hover {
          color: #fff;
        }
      }

      .group-image {
        position: relative;
        .image-gradient {
          left: 0px;
          top: calc(100% - 300px);
          position: absolute;
          height: 300px;
          width: 100%;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
        }
        img {
          border-radius: 12px;
          object-fit: contain;
          // aspect-ratio: 1 / 1;
          width: 280px;
          max-height: 600px;
        }

        .video-container {
          width: 280px;
          max-height: 600px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .play-button-container {
          position: absolute;
          top: calc(50% - 16px);
          left: calc(50% - 16px);
          display: flex;
          width: 32px;
          height: 32px;
          padding: 10px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
          aspect-ratio: 1/1;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.9);
          z-index: 2;
        }

        .video-player {
          max-width: 280px;
          max-height: 600px;
        }
      }
    }
  }
  .image-container.mobile.group-view {
    width: 100% !important;
    max-width: unset !important;
    .group-images {
      max-height: unset !important;
      height: unset !important;
      max-width: unset !important;
      .group-image {
        img,
        .video-container {
          width: 100%;
          max-height: 600px;
        }

        .video-player {
          width: 100%;
          max-height: 600px;
        }
      }
    }
  }

  .image-container.mobile {
    max-width: 100% !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
    .group-images {
      max-height: 400px !important;
      max-width: 100% !important;
      .group-image {
        img,
        .video-container {
          max-width: 100%;
          max-height: 400px;
        }

        .video-player {
          max-width: 100%;
          max-height: 400px;
        }
      }
    }
  }

  * :global(.ui-photos) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  * :global(.owl-dots) {
    margin-top: -20px !important;
  }

  * :global(.owl-dot > span) {
    background: white;
    width: 8px;
    height: 8px;
    opacity: 0.7;
  }

  * :global(.ui-photos .owl-dots .owl-dot.active > span) {
    background: #8e71ff !important;
  }

  * :global(.mobile:not(.grid) .ui-photos .owl-dots .owl-dot.active > span) {
    background: #8e71ff !important;
  }

  * :global(.ui-photos .owl-next) {
    background: white !important;
    color: black !important;
    z-index: 1;
    padding: 10px;
  }

  * :global(.ui-photos .owl-prev) {
    background: white !important;
    color: black !important;
    z-index: 1;
  }

  * :global(.group-container-hovered .ui-photos .owl-next) {
    opacity: 1 !important;
  }

  * :global(.group-container-hovered .ui-photos .owl-prev) {
    opacity: 1 !important;
  }

  * :global(.ui-single-photo) {
    margin-top: 0px !important;
  }

  * :global(.mobile .owl-stage) {
    display: -webkit-box;
    margin-top: auto;
  }

  * :global(.mobile .owl-item) {
    margin-top: auto;
    margin-bottom: auto;
  }
</style>

<div class="preload-box">
  <PreloadBox style="min-width: 280px; width: {mobile ? '100%' : '280px'}; height: 400px" />
</div>
<div class="hidden image-container {viewType}" class:mobile={mobile}>
  <div class="group-images" class:group-container-hovered={hovered}>
    <Photos
      mobile={mobile}
      preventDefaultClick={true}
      useFancyBox={false}
      photos={mediaMap}
      viewContext={'embed-post-carousel'}
      pinnedGroup={group}
      alwaysVisible={true}>
      <div class="group-image" slot="img" let:photo>
        {#if photo.content_type == 'image'}
          <img src={photo.view_urls.full_size} alt="" />
        {:else}
          <div
            class="video-container"
            on:click|preventDefault|stopPropagation={() => {
              handleVideoClick(photo.item_id);
            }}>
            {#if mobile}
              <video
                data-attr-link={photo.view_urls.full_size}
                class="video-player js-spotlight-video-player"
                poster={photo.cover}
                loop
                preload="auto"
                controlsList="nodownload"
                id="video-player-{photo.item_id}-{viewType}">
                <source src={photo.view_urls.full_size} />
              </video>
            {:else}
              <video
                data-attr-link={photo.view_urls.full_size}
                class="video-player js-spotlight-video-player"
                poster={photo.cover}
                loop
                preload="auto"
                controlsList="nodownload"
                playsinline
                id="video-player-{photo.item_id}-{viewType}">
                <source src={photo.view_urls.full_size} />
              </video>
            {/if}
            <div class="play-button-container" id="player-button-{photo.item_id}-{viewType}">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                <path
                  d="M6.75 3.30106C7.75 3.87841 7.75 5.32179 6.75 5.89914L2.25 8.49721C1.25 9.07456 0 8.35287 0 7.19817V2.00202C0 0.84732 1.25 0.125633 2.25 0.702983L6.75 3.30106Z"
                  fill="#121212" />
              </svg>
            </div>
          </div>
        {/if}
        {#if photo.id == 0}
          <div id="post-information-{postInformation.id}-{viewType}">
            <PostInformation
              mobile={mobile}
              postInformation={postInformation}
              viewType={viewType}
              on:click={() => {
                handleInformationClick(photo.item_id);
              }} />
            <div
              on:click|preventDefault|stopPropagation={() => {
                handleVideoClick(photo.item_id);
              }}
              class="image-gradient">
            </div>
          </div>
        {/if}
      </div>
    </Photos>
    <div
      class="external-platform-link"
      id="external-platform-link-{postInformation.id}-{viewType}"
      on:click|preventDefault|stopPropagation={handleOpenLink}>
      Open in {instagram ? 'Instagram' : 'TikTok'}
      {#if viewType != 'embed-post'}
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.9991 1.92969V2.46704V5.64114H9.93111V3.76434L6.03519 7.68458L5.27998 6.92466L9.17594 3.0044L7.29389 3.00441L7.29389 1.92971L10.4652 1.92969L10.9991 1.92969ZM1.71425 2.55597H5.65794V3.62734H2.07137V10.8583H9.24422V7.24282H10.3156V11.2154C10.3156 11.6099 9.99582 11.9297 9.60134 11.9297H1.71425C1.31978 11.9297 1 11.6099 1 11.2154V3.27022C1 2.87575 1.31978 2.55597 1.71425 2.55597Z"
            fill="white" />
        </svg>
      {/if}
    </div>
  </div>
</div>
